exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-56d178c6],\n.fade-leave-active[data-v-56d178c6] {\n  transition-property: opacity;\n  transition-duration: 0.25s;\n}\n.fade-enter-active[data-v-56d178c6] {\n  transition-delay: 0.25s;\n}\n.fade-enter[data-v-56d178c6],\n.fade-leave-active[data-v-56d178c6] {\n  opacity: 0;\n}", ""]);

// exports
